import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { updateSession } from "./update";
import { getAllSessionsQueryFn, getSessionInfoQueryFn, getSessionSchemaQueryFn } from "./queryFn";

export const sessionApi = createApi({
  reducerPath: "sessionApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Session"],
  endpoints: (builder) => ({
    getSessionInfo: builder.query({
      queryFn: getSessionInfoQueryFn,
      providesTags: (result, error, { type}) => [
        { type: "Session", id: type },
      ],
    }),
    getSessionSchema: builder.query({
      queryFn: getSessionSchemaQueryFn,
      providesTags: (result, error, { type}) => [
        { type: "Session-Schema", id: type },
      ]
    }),
    getAllSessions: builder.query({
      queryFn: getAllSessionsQueryFn,
      providesTags: (result, error, { type}) => [
        { type: "All-Sessions", id: type },
      ],
    }),  
    updateSession: builder.mutation({
        queryFn: updateSession,
        invalidatesTags: (result, error, { calendarType }) => 
          [{ type: "All-Sessions", id: calendarType }]
        })
    })
});

export const { useGetSessionInfoQuery, useGetAllSessionsQuery, useUpdateSessionMutation, useGetSessionSchemaQuery } = sessionApi;
